export const newsMarkdownConfig = {
	/** the title is the main heading, so the content only has headings of this level */
	allowedHeadingDepth: 2,
	allowedNodes: ["root", "paragraph", "heading", "text", "strong", "emphasis", "list", "listItem"],
} as const
